module.exports = __webpack_public_path__ + "static/a1-9cbc5048c99d8cb814148d975657875d.png";